import { ActionTree } from "vuex";
import { IPropertyEditState } from "../property-states.store";
import propertyKorfineTypesStore from "./property-korfine-types.store";
import { DataHelper } from "../../../../utils/data-helper";
import { KorfineRequestModel } from "../../../../models/property/property-korfine.model";
import { ObjectHasDeepProperty, formatPhoneNumberForKorfine } from "../../../../utils/util";

const korfineActions: ActionTree<IPropertyEditState, {}> = <ActionTree<IPropertyEditState, {}>>{
    [propertyKorfineTypesStore.Get.PUBLISH_KORFINE]: ({getters, commit}, param: number) => {
        return getters.service['getPublishKorfine'](param)
            .then((data) => {
                commit(propertyKorfineTypesStore.Set.KORFINE_REQUEST_INFO, data);
                commit(propertyKorfineTypesStore.Set.KORFINE_ASSIGN_VALUE, { ObjectId: param });
                
                return Promise.resolve(data);
                }).catch(error => Promise.reject(error))
    },
    publishKorfine: ({ getters, commit }) => {
      let payload = DataHelper.deepClone(getters.korfine) as KorfineRequestModel;

      if (ObjectHasDeepProperty(payload, 'Contract.Tenant.TaxResidenceBelgium') && payload.Contract.Tenant.TaxResidenceBelgium){
        payload.Contract.Tenant.TaxResidenceCountries = false;
        payload.Contract.Tenant.TaxResidenceNumbers = false;
      }

      if (ObjectHasDeepProperty(payload, 'Contract.Owner') && payload.Contract.Owner) {
        payload.Contract.Owner.TaxResidenceBelgium = true;
        payload.Contract.Owner.TaxResidenceCountries = false;
        payload.Contract.Owner.TaxResidenceNumbers = false;
      }
      if (payload.Contract.Owner.Person.Cellphone) {
        payload.Contract.Owner.Person.Cellphone = formatPhoneNumberForKorfine(payload.Contract.Owner.Person.Cellphone);
      }
      if (payload.Contract.Owner.Person.Phone) {
        payload.Contract.Owner.Person.Phone = formatPhoneNumberForKorfine(payload.Contract.Owner.Person.Phone);
      }
      if (payload.Contract.Owner.Partner.Cellphone) {
        payload.Contract.Owner.Partner.Cellphone = formatPhoneNumberForKorfine(payload.Contract.Owner.Partner.Cellphone);
      }
      if (payload.Contract.Owner.Partner.Phone) {
        payload.Contract.Owner.Partner.Phone = formatPhoneNumberForKorfine(payload.Contract.Owner.Partner.Phone);
      }
      if (payload.Contract.Tenant.Person.Cellphone) {
        payload.Contract.Tenant.Person.Cellphone = formatPhoneNumberForKorfine(payload.Contract.Tenant.Person.Cellphone);
      }
      if (payload.Contract.Tenant.Person.Phone) {
        payload.Contract.Tenant.Person.Phone = formatPhoneNumberForKorfine(payload.Contract.Tenant.Person.Phone);
      }
      if (payload.Contract.Tenant.Partner.Cellphone) {
        payload.Contract.Tenant.Partner.Cellphone = formatPhoneNumberForKorfine(payload.Contract.Tenant.Partner.Cellphone);
      }
      if (payload.Contract.Tenant.Partner.Phone) {
        payload.Contract.Tenant.Partner.Phone = formatPhoneNumberForKorfine(payload.Contract.Tenant.Partner.Phone);
      }

      return getters.service.publishKorfine(payload)
      .then((data) => { 
        return Promise.resolve(data);
      }).catch(error => Promise.reject(error))
  }

}
export default korfineActions;